<template>
  <div></div>
</template>
<script>
export default {
  props: {
    siteId: {
      type: String,
      required: true
    }
  },
  mounted() {
    let hotjarScript = document.createElement("script");
    let inlineScript = document.createTextNode(`(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${this.siteId},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`);
    hotjarScript.appendChild(inlineScript);
    document.head.appendChild(hotjarScript);
  }
};
</script>
